import { render, staticRenderFns } from "./ItemsTable.vue?vue&type=template&id=01ba95ca&scoped=true"
import script from "./ItemsTable.vue?vue&type=script&lang=js"
export * from "./ItemsTable.vue?vue&type=script&lang=js"
import style0 from "./ItemsTable.vue?vue&type=style&index=0&id=01ba95ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ba95ca",
  null
  
)

export default component.exports